export { default as AlertLabel, AlertLabelPropsSize, AlertLabelPropsType } from './AlertLabel';
